export const AiAgentPageData = {
    bannerContent: {
        shortHeading: "AI Agent Development Services",
        mainHeading: "Building Smarter Enterprises With Next-Generation <span>AI Agents</span>",
        description: "Our custom AI agent development services help you automate complex workflows, improve customer interactions, & build smart AI assistants designed to fit your business goals. We deploy AI agents, such as process automation & AI sales agents, to streamline operations, boost efficiency, & drive growth.",
    },
    aiagentServices: {
        heading: "Where Customer Experience Meets <span>Intelligent</span> Efficiency",
        shortHeading: "AI Agent Development Services",
        description: "Our AI Agent Development Services empower businesses with intelligent automation & smart voice agents. We enhance customer experiences, streamline workflows, & drive efficiency, helping organizations achieve scalable growth with <a href='/generative-ai-development-services' class='text-black' target='_blank'>next-generation AI solutions</a>.",
        cardsData: [
            {
                "title": "AI Agent Consulting & Strategy",
                "description": "If you want to make the most of agentic AI to optimize workflow efficiency & outshine competitors, you must first identify which agent type best fits your industry. Bitsclan is here. Our AI agent consulting experts work closely with you to design a solution that aligns with your goals, ensuring a seamless transition from concept to execution."
            },
            {
                "title": "Custom AI Agent Development",
                "description": "We provide top custom AI agent development services tailored to your business needs, using advanced tools like AutoGen Studio & CrewAI. Our <a href='/ai-ml-development-services' class='text-black' target='_blank'>artificial intelligence experts</a> build AI agents designed to match both current & future goals."
            },
            {
                "title": "Conversational AI Agents Development",
                "description": "We develop advanced conversational AI Agents in order to create voice agents, customer support technologies, & many more applications that are user-friendly & aim to provide human-like interaction. The AI-enabled voice assistants enhance the user experience by understanding & engaging with inquiries correctly & naturally."
            },
            {
                "title": "AI Agent Integration",
                "description": "We ensure seamless AI agents integration into your workflows, optimizing data flow, reducing latency, & enabling smooth communication using advanced microservices, containerization, & API strategies for single-and multi-agent systems."
            },
            {
                "title": "Continuous Improvement & Maintenance",
                "description": "At Bitsclan, our AI agent development services include continuous improvement & maintenance to keep your AI running at peak performance. Our experts fine-tune models, monitor results, & update features regularly so your business always benefits from the latest AI agent development company innovations."
            }
        ]
    },
    whyUsContent: {
        shortHeading: " 200+ Projects in AI Agent & Voice Agent Development",
        heading: " Choose Us for AI Agent Development",
        greenHeading: "Why Global Enterprises",
        image: "/images/why-us-section/ai-agent-why-us.avif",
        altText: "custom ai agent development services",
        content: "From <a href='/ai-automation-agency' class='text-black' target='_blank'>sales automation</a> to customer support, our AI agent & AI voice agent development empowers organizations with reliable, scalable, & future-ready solutions. We help businesses innovate & thrive in competitive industries.",
        stats: [
            // {
            //     title: "AI Services Since",
            //     number: "2017",
            // },
            {
                title: "AI Agent Projects",
                number: "200+",
            },
            {
                title: "AI Agent Builders",
                number: "130+",
            },
            {
                title: "AI Agents Industries",
                number: "14+",
            },
        ],
        cta: {
            text: "Build Your AI Agents",
            link: "/contact-us",
        }
    },
    testimonialData: {
        mainHeading: "Real Voices. Real <span>Impact.</span> Proven Results.",
        description: " Our AI agent development services are relied upon across the globe. Discover & explore how clients benefited from seamless automation, accelerated decision-making, & industry specific results that deliver real efficiency & innovation.",
        testimonials: [
            {
                name: "Michael Turner",
                enterprise: "Enterprise Automation",
                country: "Austin, US",
                countryFlagImage: "/images/testimonials/flags/usa-flag.png",
                designation: "CTO at BrightPath Logistics",
                profileImage: "/images/testimonials/michael.avif",
                logoImage: "/images/logo-2.png",
                text: "Bitsclan built a chatbot that now handles most of our customer queries. Response times are down to seconds, & our support team is free to focus on complex issues. It’s been a huge boost to efficiency & customer satisfaction.",
                serviceTags: [
                    { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
                    { title: "AI Automation", link: "/ai-automation-agency" },
                    { title: "Generative AI", link: "/generative-ai-development-services" }
                ]
            },
            {
                name: "Sophie Keller",
                enterprise: "Healthcare AI",
                country: "Florida, US",
                countryFlagImage: "/images/testimonials/flags/usa-flag.png",
                designation: "Head of Digital Transformation at Meditech Solutions",
                profileImage: "/images/testimonials/sophie.avif",
                logoImage: "/images/logo-2.png",
                text: "With Bitsclan’s agentic AI, we’ve automated routine admin tasks like scheduling & reporting. Our staff now spends more time with patients, & errors have dropped noticeably. The solution fit right into our workflow.",
                serviceTags: [
                    { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
                    { title: "AI Automation", link: "/ai-automation-agency" },
                    { title: "Generative AI", link: "/generative-ai-development-services" }
                ]
            },
            {
                name: "Sarah Coleman",
                enterprise: "Construction & Industrial Equipment",
                country: "Illinois, US",
                countryFlagImage: "/images/testimonials/flags/usa-flag.png",
                designation: "Training & Product Specialist at American Moisture Test",
                profileImage: "/images/testimonials/sarah.avif",
                logoImage: "/images/testimonials/logo-amt.png",
                text: "Partnering with Bitsclan allowed us to digitize our testing workflow. From product tracking to client reporting, everything is now managed in one unified system. The team’s industrial understanding and precision execution exceeded our expectations.",
                serviceTags: [
                    { title: "Custom Web Development", link: "/custom-software-development-services" },
                    { title: "Equipment Management System", link: "#" },
                    { title: "ERP Integration", link: "#" }
                ]
            }
        ]
    },
    caseStudyContent: {
        shortHeading: "AI Agent & Voice Agent Case Studies",
        heading: "Real-World Success <span>Stories</span> Demonstrating Our Enterprise Impact",
        description: "Bitsclan offers advanced AI agent development & voice agent development services to help companies save time, reduce costs, & engage customers more effectively. As a trusted virtual AI agent development agency, we design scalable AI assistants backed by proven results & real business outcomes."
    },
    engagementModelContent: {
        shortHeading: "Engagement Models",
        heading: "Engagement Models Designed Around Your Business Needs",
        subheading: "You are at the right place. From strategy to delivery, we customize AI agent development services to match your workflow & accelerate results.",
        models: [
            {
                index: "1.",
                title: "Staff Augmentation",
                description: "Need a couple of extra AI agent engineers on your team? Get senior ai voice agent developers who integrate directly into your internal team.",
                icon: "/images/engagement-model-gifs/hourly-icon.svg",
                iconWidth: 40,
            },
            {
                index: "2.",
                title: "Dedicated Teams",
                description: "Need multiple AI agent development teams to manage projects at once? We deploy expert pods for builds or streams, set clear priorities, & our tech PMs ensure fast, consistent delivery.",
                icon: "/images/engagement-model-gifs/price-icon.svg",
                iconWidth: 35,
            },
            {
                index: "3.",
                title: "AI Agent Project Outsourcing",
                description:
                    "Let us handle the whole project, from strategy & planning through launch. You set the vision & we will do the work, with full transparency & control.",
                icon: "/images/engagement-model-gifs/retainer-icon.svg",
                iconWidth: 40,
            },
        ],
        cta: {
            text: "Expert Talent on Your Terms",
            button: "Schedule a Call with AI Agent Expert",
            link: "/contact-us",
        },
    },
    trendingInsights: {
        heading: "Enterprise Insights Into AI Agents & Voice Innovation",
        description:
            "Learn the latest in AI, agentic AI & voice AI agent development. Get practical insights, expert opinions, & strategies to stay ahead in the tech landscape.",
    },
    roadmapContent: {
        mainHeading: "Our Proven AI ML Development Roadmap to ",
        // greenHeading: "Ensure Your Success",
        sectionDescription:
            "As a leading ai development company in usa, we have developed a structured roadmap to ensure the success of your projects. From initial discovery to ongoing support, we follow a systematic approach that guarantees alignment with your business goals, delivers high-quality solutions, & provides continuous improvement. Here’s how we do it:",
    },
    faqSection: {
        heading: "What Businesses Need to Know About Agentic AI",
        questionAnswers: [
            {
                id: "collapseOne",
                question: "What Exactly Are AI Agents & AI Voice Agents?",
                answer:
                    "AI agents are intelligent software programs that autonomously perform tasks like customer support, data analysis, & workflow automation. AI voice agents are a type of AI agent that interact through speech, handling calls or voice commands. By integrating these agents, businesses can improve efficiency, reduce costs, & allow human staff to focus on complex tasks, while AI handles routine or repetitive work.",
            },
            {
                id: "collapseTwo",
                question: "How do you engineer intelligent agents similar to ChatGPT AI agents?",
                answer:
                    "We engineer intelligent agents like ChatGPT AI agents by combining advanced natural language processing (NLP) with deep learning techniques. Models are trained on massive datasets to understand, generate, & respond to human language accurately. Continuous fine-tuning & reinforcement learning ensure the agents improve over time & adapt to new contexts.",
            },
            {
                id: "collapseThree",
                question: "How do you ensure the quality & performance of your AI agents?",
                answer:
                    "We guarantee the quality & performance of our AI agents through complete testing & validation. Each AI agent undergoes multiple checks, including functionality, performance, & user acceptance testing. After deployment, we continuously monitor & fine-tune them to maintain peak efficiency.",
            },
            {
                id: "collapseFour",
                question: "Which engagement model for AI agent development should I choose?",
                answer:
                    "The right engagement model for your AI agent development depends on your project’s scale, complexity, budget, & regulatory requirements. We recommend scheduling a consultation so we can understand your business goals & guide you toward the most effective model.",
            },
            {
                id: "collapseFive",
                question: "How do you ensure the security & integrity of AI agents?",
                answer:
                    "We implement strong security measures & protocols in our AI agents to protect data & maintain system integrity. Continuous monitoring, threat detection, & proactive mitigation ensure that critical information & infrastructure remain secure & uncompromised.",
            },
            {
                id: "collapseFive",
                question: "What types of tasks can AI Agents automate?",
                answer:
                    "AI agents can handle many tasks, from answering customer questions & managing returns to processing invoices, tracking orders, onboarding staff, running payroll, checking inventory, creating content, pulling data, & generating reports efficiently.",
            },
        ],
    },
    companyCta: {
        heading: "Design. Build. Scale. Your AI Agent Journey Begins Now.",
        // subHeading: "See how our expert developers can help.",
        buttonText: "Schedule a Call",
    },
    industries: {
        shortHeading: "",
        heading: "",
        description: "",
        serviceTags: [
            { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
            { title: "AI Automation", link: "/ai-automation-agency" },
            { title: "Generative AI", link: "/generative-ai-development-services" }
        ],
        tabData: [
            {
                id: 1,
                slug: "healthcare",
                title: "Healthcare",
                description: "Our healthcare AI agent services include voice agents & ChatGPT-driven assistants. We design automated systems that integrate with EHR & patient management platforms to deliver better care, reduce workload, & stay compliant with healthcare regulations.",
                image: "healthcare.avif",
                icon: "/images/heart.png",
            },
            // {
            //     id: 2,
            //     slug: "fintech",
            //     title: "Fintech",
            //     description: "We build AI agent & voice agent solutions for fintech companies, enabling them to handle routine inquiries, transactions, & account updates with speed & accuracy. Our agentic AI systems ensure secure payments & deliver real-time financial insights across web & mobile platforms.",
            //     image: "fintech.png",
            //     icon: "/images/Fintech.png",
            // },
            {
                id: 3,
                slug: "retail-ecommerce",
                title: "E-commerce & Retail",
                description: "With our E-commerce & Retail AI  voice agent development services, we build intelligent agents that improve response times, personalize product recommendations, & simplify checkout processes. Our agentic AI solutions help brands connect with customers more effectively, boost sales, & strengthen loyalty.",
                icon: "/images/ecommerce-icon.png",
                image: "ecommerce.avif",
            },
            {
                id: 4,
                slug: "real-estate",
                title: "Real Estate",
                description: "As an AI agent development company, we help real estate teams streamline operations with intelligent agents. From property & project management to client interactions & secure transactions, our AI-driven workflows make processes faster, safer, & more efficient.",
                icon: "/images/RealEstate.png",
                image: "realestate.avif",
            },
            {
                id: 6,
                slug: "education",
                title: "Education",
                description: "We make education smarter with our AI agent developer solutions. Whether automating back-end tasks or creating intelligent classroom assistants, our AI agents streamline operations & support students, teachers, & institutions for improved performance.",
                icon: "/images/education-icon.png",
                image: "education.avif",
            },
            {
                id: 5,
                slug: "automotive-logistics",
                title: "Automotive & Logistics",
                description:
                    "Our AI voice agent solutions transform the automotive & logistics industries by streamlining vehicle tracking, supply chain visibility, & customer communication. From managing inventory & fleets to automating workflows & reducing errors, we deliver real-time efficiency & seamless experiences for businesses & their customers.",
                icon: "/images/automotive-icon.png",
                image: "automotive.avif",
            },
            {
                id: 9,
                slug: "gaming-entertainment",
                title: "Entertainment & Gaming",
                description:
                    "Our AI voice agent engineers help the entertainment & gaming industries optimize content management, automate audience analytics, & safeguard intellectual property. We enhance workflows, improve player communication, & streamline operations to deliver more engaging & seamless experiences for audiences & players alike.",
                icon: "/images/entertainment.avif",
                image: "entertainmentMain.avif",
            }
            // {
            //     id: 11,
            //     slug: "social-networking",
            //     title: "Social Networking",
            //     description: "We provide social media AI agents to boost engagement, automate analytics, & ensure secure data management. Our AI solutions streamline interactions while keeping workflows efficient & protected.",
            //     icon: "/images/SocialNetworking.png",
            //     image: "Social.png",
            // },
            // {
            //     id: 12,
            //     slug: "telecom",
            //     title: "Telecom",
            //     description: "Our AI agents in telecom streamline processes like billing management, network optimization, & customer relationship operations. By deploying these agents, we help telecom companies boost efficiency, minimize errors, & consistently deliver better experiences to their customers.",
            //     icon: "/images/Telecom.png",
            //     image: "telecom.png",
            // },
            // {
            //     id: 13,
            //     slug: "energy",
            //     title: "Energy",
            //     description: "We provide advanced AI intelligent agent solutions for the energy sector. From smart grid management & resource optimization to secure trading platforms, our intelligent agents help energy companies operate smarter & more efficiently.",
            //     icon: "/images/Energy.png",
            //     image: "energy.png",
            // },
            // {
            //     id: 14,
            //     slug: "agriculture",
            //     title: "Agriculture",
            //     description: "Our agentic AI in agriculture helps farmers optimize irrigation, monitor their crop more efficiently, & manage their resources better. It provides increased yields while also allowing for sustainable & smarter farming practices.",
            //     icon: "/images/industries-icons/Agriculture.svg",
            //     image: "Agriculture.avif",
            // }
        ]
    },
    techStack: {
        tabs: [
            "Programing Languages",
            "AI/ML Frameworks",
            "Natural Language Processing",
            "Speech Recognition & Synthesis",
        ],

        tabItems: [
            {
                tab: "Programming Languages",
                icon: "/images/ai-agent-stacks/javascript.png",
                altText: "JavaScript frontend scripting",
            },
            {
                tab: "Programming Languages",
                icon: "/images/ai-agent-stacks/python.png",
                altText: "Python backend language",
            },
            {
                tab: "AI/ML Frameworks",
                icon: "/images/ai-agent-stacks/PyTorch.svg",
                altText: "PyTorch deep learning",
            },
            {
                tab: "AI/ML Frameworks",
                icon: "/images/ai-agent-stacks/TensorFlow.svg",
                altText: "TensorFlow ML library",
            },
            {
                tab: "AI/ML Frameworks",
                icon: "/images/ai-agent-stacks/Jax.svg",
                altText: "JAX numerical computing",
            },
            {
                tab: "AI/ML Frameworks",
                icon: "/images/ai-agent-stacks/KerasNPL.svg",
                altText: "Keras neural networks",
            },
            {
                tab: "Natural Language Processing",
                icon: "/images/ai-agent-stacks/open-ai.svg",
                altText: "OpenAI GPT model",
            },
            {
                tab: "Natural Language Processing",
                icon: "/images/ai-agent-stacks/gemeni.png",
                altText: "Gemini NLP system",
            },
            {
                tab: "Natural Language Processing",
                icon: "/images/ai-agent-stacks/bert.png",
                altText: "BERT language representation",
            },
            {
                tab: "Natural Language Processing",
                icon: "/images/ai-agent-stacks/gpt.png",
                altText: "GPT-4 language model",
            },
            {
                tab: "Speech Recognition & Synthesis",
                icon: "/images/ai-agent-stacks/Mistral.png",
                altText: "Mistral AI language",
            },
            {
                tab: "Speech Recognition & Synthesis",
                icon: "/images/ai-agent-stacks/liama3.2.png",
                altText: "LLaMA ASR model",
            },
            {
                tab: "Speech Recognition & Synthesis",
                icon: "/images/ai-agent-stacks/qwen.png",
                altText: "Qwen TTS system",
            },
            {
                tab: "Speech Recognition & Synthesis",
                icon: "/images/ai-agent-stacks/zleuth.png",
                altText: "Eleuther AI framework",
            },
            {
                tab: "Speech Recognition & Synthesis",
                icon: "/images/ai-agent-stacks/hugging-face.png",
                altText: "Hugging Face platform",
            },
        ]
    },
};
